module.exports = __webpack_public_path__ + "img/selected7-min.c26727d1.png";